// assets
import DashboardIcon from "@mui/icons-material/Dashboard";
import BadgeIcon from '@mui/icons-material/Badge';

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  type: "group",
  children: [
    // {
    //   id: "dashboard",
    //   title: "Dashboard",
    //   type: "item",
    //   url: "/dashboard",
    //   icon: DashboardIcon,
    //   breadcrumbs: false,
    // },
    {
      id: "account_dashboard",
      title: "Accounts",
      type: "item",
      url: "/account-dashboard",
      icon: DashboardIcon,
      breadcrumbs: false,
    },
    {
      id: "portfolio_dashboard",
      title: "Portfolio",
      type: "item",
      url: "/portfolio",
      icon: BadgeIcon,
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
